import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

const NotFound = lazy(() => import('../../container/pages/404'));
const CreateBannerForm = lazy(() => import('../../container/banners/CreateBannerForm'));
const EditBannerForm = lazy(() => import('../../container/banners/EditBannerForm'));
const BannersList = lazy(() => import('../../container/banners'));

function BannersRoute() {
  return (
    <Routes>
      <Route path="/" element={<BannersList />} />
      <Route path="/add-banner" element={<CreateBannerForm />} />
      <Route path="/:id/edit" element={<EditBannerForm />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default BannersRoute;
